import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const contactClasses = tv({
	slots: {
		wrapper: 'lg:max-w-[172rem] lg:mx-auto mt-5 lg:mt-[16rem]',
		base: 'bg-mainPink px-2 py-4 lg:p-3 lg:p-6 lg:mx-4 lg:rounded-l grid grid-cols-4 lg:grid-cols-6 lg:gap-x-6',
		formContainer: 'col-span-4',
		infosContainer: 'col-span-4 lg:col-span-2 border-t border-black pt-2 mt-4 lg:mt-0',
		form: 'grid grid-cols-4 gap-x-2 gap-y-2 md:gap-y-3',
		inputLabel: 'ml-[1.5rem]',
		inputContainer: 'relative flex flex-col gap-1 col-span-4 lg:col-span-2',
		inputContainerLong: 'relative flex flex-col gap-1 col-span-4',
		input:
			'rounded-full px-[1.5rem] py-[0.9rem] lg:px-2 lg:py-[1.3rem] text-input-mobile md:text-xs border-[0.2rem] bg-white transition-colors focus:outline-none focus:bg-white/85',
		selectInput:
			'relative rounded-full text-indent-[1.5rem] lg:py-[1.3rem] text-input-mobile md:text-xs border-[0.2rem] bg-white transition-colors focus:outline-none focus:bg-white/85 py-[0.9rem] lg:py-[1.3rem] px-[1.5rem] lg:px-2 appearance-none',
		textarea:
			'rounded-m px-[1.5rem] py-[0.9rem] lg:p-2 text-input-mobile md:text-xs resize-none border-[0.2rem] bg-white transition-colors focus:outline-none focus:bg-white/85 [&:not(:placeholder-shown)]:bg-white/30',
		button: 'col-span-2 w-fit',
		honeypot: 'opacity-0 absolute top-0 left-0 h-0 w-0 z-[-1]',
		svgArrow:
			'fill-current h-[1.5rem] w-[1.5rem] absolute top-[calc(50%+1.5rem)] -translate-y-1/2 right-[1.5rem] lg:right-2',
	},
	variants: {
		select: {
			true: {
				svgArrow: 'fill-black',
			},
			false: {
				svgArrow: 'fill-[#9C9C9C]',
				input: '[&:not(:placeholder-shown)]:bg-white/30',
			},
		},
	},
})

export type ContactVariants = VariantProps<typeof contactClasses>
